export default "__VITE_ASSET__yB$G8jzB__"